import { Input } from "@ui/input"
import { Label } from "@ui/label"
import { Textarea } from "@ui/textarea"

import { CollectionItem } from "@vertesia/common"

interface ReportDetailsPanelProps {
    collection: CollectionItem | undefined
    title: string
    description: string
    setTitle: (value: string) => void
    setDescription: (value: string) => void
}
export function ReportDetailsPanel({ collection, title, description, setTitle, setDescription }: Readonly<ReportDetailsPanelProps>) {
    return (
        <>
            <div className="space-y-2">
                <Label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    Report Title *
                </Label>
                <Input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="e.g., Q1 Progress Report to EPA"
                />
                <p className="text-sm text-gray-500">
                    Choose a descriptive name that clearly identifies your report
                    {
                        collection?.name && (
                            <span className='italic font-medium text-gray-600'> (needs to be different from original report name)</span>
                        )
                    }
                </p>
            </div>
            <div className="space-y-2 flex-1 flex flex-col">
                <Label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    Report Description *
                </Label>
                <Textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Describe the purpose and scope of this report..."
                    className='min-h-[80px] flex-1'
                />
                <p className="text-sm text-gray-500">Provide a brief overview of what this report will cover</p>
            </div>
        </>
    )
}
